import React, { useContext } from "react";
import {
  Badge,
  Button,
  LegacyCard as Card,
  Text,
  Link,
  InlineStack,
  Thumbnail,
  Box,
  BlockStack,
  Divider,
} from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { statusHelper, baseHelper, imageHelper } from "lib/helpers";
import LineItemProperties from "app/orders/modules/generic/service/lineItemProperties";
import { StyledCard } from "app/orders/modules/operator/features/view/genericStyled";
import { useNavigate, useParams } from "react-router-dom";

const FulfilledLineItems = (props) => {
  const { data, fulfilledData, getSlipText, lineItemArray, packingSlipAccessData, setFulfillAmount } = props;
  const { cms, userData } = useContext(PrivateContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const { PARTIAL, FULFILLED, REFUND } = constant;
  const currentUserData = baseHelper.getResponseData(userData, constant.gql.GET_CURRENT_USER);

  const amount = [];
  const vendorsSum = [];
  const countItems = 0;
  // fulfilledData &&
  //   fulfilledData.length &&
  //   fulfilledData.forEach((dataLine) => {
  //     const { id: shopifyLineItemId = "", totalPrice = 0, vendor, totalQuantity } = dataLine;
  //     const getItem = lineItemArray.find((item) => item.shopifyLineItemId === shopifyLineItemId);
  //     const { markUpPrice = 0, sellerDiscount = 0 } = getItem;
  //     vendorsSum.push(vendor);
  //     amount.push(
  //       parseFloat(totalPrice) - parseFloat(totalQuantity * markUpPrice) + parseFloat(totalQuantity * sellerDiscount)
  //     );
  //     countItems += 1;
  //     return [amount];
  //   });

  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;

  const stringToNumber = amount.map((item) => parseFloat(item));
  // const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);
  let totalAmount = 0;

  const isVendor = baseHelper.isVendor(currentUserData);

  const lineItems = fulfilledData.map((lineItem, idx) => {
    const { id: shopifyLineItemId = "", name = "", sku, totalPrice, totalQuantity } = lineItem || {};
    const getItem = lineItemArray.find((item) => item.shopifyLineItemId === shopifyLineItemId);
    const {
      fulfillmentStatus,
      fulfillmentType,
      image = "",
      isProductDeleted,
      isVendorDeleted,
      moneyFormat: lineMoneyFormat,
      price,
      // markUpPrice = 0,
      properties,
      // sellerDiscount = 0,
      productId,
      rejectedByVendor,
      vendor,
      vendorId,
    } = getItem || {};

    const lineTotalPrice = parseFloat(price);
    totalAmount += lineTotalPrice;

    const lineItemKey = `lineItem${idx}`;
    const lineImage = imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;

    const moneyFormat = lineMoneyFormat || constant.symbol.DOLLAR;
    const isServiceLineItem = baseHelper.isServiceLineItem(fulfillmentType, properties);
    const status = statusHelper.getBadgeStatus(isServiceLineItem ? constant.COMPLETED : constant.FULFILLED);
    const badgeType = baseHelper.getBadgeType(constant.FULFILLED);

    const lineItemName = <div className="productName">{name}</div>;
    const productURL = isServiceLineItem ? `/products/service/edit/${productId}` : `/products/edit/${productId}`;

    return (
      <>
        <div key={lineItemKey} className="fulfilled-Secn">
          <Box padding={"400"}>
            <InlineStack wrap={false} gap="400">
              <Thumbnail size="large" source={lineImage} alt={name} />
              <Box width="100%">
                <InlineStack align="space-between">
                  <div className="ellipsis">
                    <BlockStack gap="100" inlineAlign="start">
                      {(isProductDeleted && (lineItemName || "")) || (
                        <Link onClick={() => navigate(productURL)}>{lineItem.name || ""}</Link>
                      )}

                      <Text variant="bodySm" as="p">
                        <Text as="span" tone="subdued">
                          {vendor && vendorId
                            ? isVendor || isVendorDeleted
                              ? [`${cms("label.vendor")}: `, vendor, <br />]
                              : [
                                  `${cms("label.vendor")}: `,
                                  <Link onClick={() => navigate(constant.PROVIDER_VIEW + vendorId)}>
                                    {vendor || ""}
                                  </Link>,
                                  <br />,
                                ]
                            : ""}
                        </Text>
                        <LineItemProperties
                          variation={constant.SUBDUED}
                          properties={properties}
                          isServiceLineItem={isServiceLineItem}
                        />
                        {isServiceLineItem ? (
                          ""
                        ) : (
                          <Text as="span" tone="subdued">
                            {cms("label.skuList")} {sku}{" "}
                          </Text>
                        )}
                      </Text>
                      <InlineStack gap={"300"}>
                        <Badge tone={badgeType} className="text-capitalize">
                          {status}
                        </Badge>
                        {rejectedByVendor && (
                          <Badge tone={baseHelper.getBadgeType(constant.REJECTED)} className="text-capitalize">
                            {constant.REJECTED_BY_VENDOR}
                          </Badge>
                        )}
                        {!(fulfillmentStatus === constant.REFUND) && (
                          <span className="packing-slip-link">
                            {[FULFILLED, PARTIAL, REFUND].includes(fulfillmentStatus) &&
                              packingSlipAccessData.isFulfilled && (
                                <Button
                                  variant="plain"
                                  icon={NoteIcon}
                                  onClick={() => window.open(`/order-slip/${id}`)}
                                >
                                  {getSlipText(fulfillmentType)}
                                </Button>
                              )}
                          </span>
                        )}
                      </InlineStack>
                    </BlockStack>
                  </div>
                  <InlineStack gap="400">
                    <Text as="span">
                      {`${cms("label.qty")}:`}
                      {totalQuantity}
                    </Text>
                    <Text as="span">
                      {moneyFormat}
                      {(lineTotalPrice && lineTotalPrice.toFixed(2)) || constant.value.ZERO}
                    </Text>
                  </InlineStack>
                </InlineStack>
              </Box>
            </InlineStack>
          </Box>
        </div>
        <Divider />
      </>
    );
  });

  if (totalAmount) {
    setFulfillAmount(totalAmount);
  }

  const moneyFormat = data && data.moneyFormat;
  const totalFulfill = (
    <Card.Section>
      <InlineStack align="space-between">
        <Text as="span" fontWeight="semibold">
          {cms("label.total")}
        </Text>
        <InlineStack gap="400">
          <Text variant="bodySm" as="p">
            {" "}
            (
            {countItems > 1
              ? `${countItems}
                ${cms("label.items")} from ${addVendorTxt}`
              : `${countItems}
                ${cms("label.item")} from ${addVendorTxt}`}
            )
          </Text>
          <Text as="span" fontWeight="semibold">
            {`${moneyFormat || constant.symbol.DOLLAR}${totalAmount.toFixed(2)}`}
          </Text>
        </InlineStack>
      </InlineStack>
    </Card.Section>
  );
  return [lineItems, totalFulfill];
};

export default FulfilledLineItems;
